/* eslint-disable react/require-default-props */
import React from 'react'
import {Row, ButtonPrimary, Col} from '@modifi/ui'

import {StyledAddIcon} from './styles'

interface SummaryPageHeaderProps {
  ctaText: string
  onCreate: (...args: any[]) => void
  isDisabled?: boolean
  hideCta?: boolean
}

const SummaryPageHeader: React.FC<SummaryPageHeaderProps> = ({
  ctaText,
  onCreate,
  isDisabled = false,
  hideCta = false,
}) => (
  <Row mb={32} alignItems="center">
    {!hideCta && (
      <Col>
        <ButtonPrimary data-target="create-entry" onClick={onCreate} disabled={isDisabled} icon>
          <StyledAddIcon />
          {ctaText}
        </ButtonPrimary>
      </Col>
    )}
  </Row>
)

export default SummaryPageHeader
